import { create } from 'zustand';
import { useId, useLayoutEffect } from 'react';

export const useFooterNoticeStore = create<{ notices: Record<string, string> }>(() => ({
  notices: {},
}));

/** Route-specific restriction copy is presented by the footer without covering the sale. */
export function useFooterNotice(message: string | null) {
  const id = useId();
  useLayoutEffect(() => {
    if (message)
      useFooterNoticeStore.setState((state) => ({ notices: { ...state.notices, [id]: message } }));
    return () =>
      useFooterNoticeStore.setState((state) => {
        const notices = { ...state.notices };
        delete notices[id];
        return { notices };
      });
  }, [id, message]);
}
